import { styled, Tab, Tabs } from '@mui/material'

export const StyledTabs = styled(Tabs)(() => ({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}))

export const StyledTab = styled(Tab)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '27.5px 23px',
  transition: 'all .3s ease-out',
  position: 'relative',
  textTransform: 'none',
  alignItems: 'start',
  fontSize: '1.125rem',
  '&:not(.Mui-selected):hover': {
    background: '#F5F6FA',
  },
  '&.Mui-selected': {
    fontWeight: 700,
  },
  '&:before': {
    content: "' '",
    position: 'absolute',
    height: 35,
    width: 0,
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    background: '#1976D2',
    borderRadius: 8,
    transition: 'all .1s ease-out',
  },
  '&.Mui-selected:before': {
    width: 4,
  },
}))

export const TitleAndButtonWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: 32,
}))
